const MembershipsIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 2H19L23 8V9L13 22H11L1 9V8L5 2Z" fill="#009DC1" />
        <path d="M8 2H5L1 8H6.5L8 2Z" fill="white" />
        <path opacity="0.5" d="M1 9L11 22L6.5 9H1Z" fill="#49DAFF" />
        <path d="M23 8L19 2H16L17.5 8H23Z" fill="#49DAFF" />
        <path d="M13 22L23 9H17.5L13 22Z" fill="#157A9C" />
        <path opacity="0.5" d="M7.5 9L12 22L16.5 9H7.5Z" fill="#49DAFF" />
        <path d="M16.5 8L15 2H9L7.5 8H16.5Z" fill="#49DAFF" />
        <path d="M7.5 8L15 2H9L7.5 8Z" fill="white" />
    </svg>
)

MembershipsIcon.displayName = 'MembershipsIcon'

export default MembershipsIcon
